import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import { TrialCheckoutSubscriptionSummary } from "~ui-components/components/organisms/trial-checkout/checkout-subscription-summary";
import { AccountBillingForm } from "~ui-components/components/organisms/user-accounts/billing-form";

export const TrialCheckout = (props) => {
	return (
		<DashboardContentLayout pageTitle="Checkout">
			<Stack
				spacing={4}
				component="form"
				onSubmit={props.form.handleSubmit}>
				<Grid
					container
					spacing={4}>
					<Grid
						size={{
							md: 8,
							xs: 12,
						}}>
						<AccountBillingForm form={props.form} />
					</Grid>
					<Grid
						size={{
							md: 4,
							xs: 12,
						}}>
						<TrialCheckoutSubscriptionSummary {...props} />
					</Grid>
				</Grid>
			</Stack>
		</DashboardContentLayout>
	);
};
